var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.7H0.3V1.3H5H5.3V1V0.3H10.7V1V1.3H11H15.7V2.7H15H14.7V3V16C14.7 16.4699 14.5363 16.8648 14.2007 17.201C13.8653 17.537 13.4707 17.7006 13.0004 17.7H13H3C2.53012 17.7 2.1356 17.5363 1.80013 17.2009C1.46468 16.8654 1.30059 16.4705 1.3 15.9997C1.3 15.9997 1.3 15.9997 1.3 15.9996L1.3 3V2.7H1ZM13.3 3V2.7H13H3H2.7V3V16V16.3H3H13H13.3V16V3ZM6.7 5.3V13.7H5.3V5.3H6.7ZM10.7 5.3V13.7H9.3V5.3H10.7Z",
    stroke: "black",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.5a417097b680e4b000cbd6c949443beb.svg";
export { ForwardRef as ReactComponent };